import {AvailabilityApiResponseTime} from '../../../server/routes/availability/types';
import {generateTimeslotData} from '../TimeSlotList/generateTimeslotData';

const transformHourToMinutes = (time: string) => {
  const timeParts = time.split(':');
  return Number(timeParts[0]) * 60 + Number(timeParts[1]);
};

export const getSelectedStartTime = ({
  selectedDayTimeSlots,
  time,
}: {
  selectedDayTimeSlots: AvailabilityApiResponseTime[] | undefined;
  time: string | null;
}) => {
  // no time slots available
  if (!selectedDayTimeSlots || !selectedDayTimeSlots.length) {
    return null;
  }

  // if a user had previously selected a day with no time slots available
  // then the selected start time will have the value of null.
  // in this case return the first available start time from the newly selected day
  if (time === null) {
    return generateTimeslotData(selectedDayTimeSlots[0]);
  }

  const transformedSelectedStartTime = transformHourToMinutes(time);

  const startTime = selectedDayTimeSlots.find(({startTime}) => {
    const transformedStartTime = transformHourToMinutes(startTime);
    return transformedStartTime >= transformedSelectedStartTime;
  });

  // if the newly selected day does not include the previously selected start time or
  // any time later than that, default to returning the last available time slot from the
  // selected day
  const timeslotData = generateTimeslotData(
    startTime
      ? startTime
      : selectedDayTimeSlots[selectedDayTimeSlots.length - 1],
  );
  return timeslotData;
};
